import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

function ServiceTabTwo() {
    return (
        <Container>
            <Row style={{ justifyContent: 'center' }} >
                <Row className='mt-3'>
                    <Col className='service_des_title' > EPABX SYSTEM </Col>
                </Row>
                <Row className='mt-3'>
                    <Col>
                        <p className='service_des_p' >
                            EPABX (Electronic Private Automatic Branch Exchange) is a device used in offices, hotels and many other places for communication. It is independent and can work without any phone lines (service providers). An EPABX also allows you to have more phones than physical phone lines and allows free calls between users.
                        </p>
                        <p className='service_des_p'>
                            EPABX phone systems are usually much more flexible than proprietary systems, as they use open standards and interfaces. Modern EPABX phone systems are based on standard hardware, which is cheaper and can more easily be replaced than a closed system.
                        </p>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col className='service_des_title'> We Are Your Personal Security Expert  </Col>
                </Row>
                <Row className='mt-3'>
                    <Col className='service_des_p' >
                        <p className='service_des_p'> Today, all infrastructures are using these security services and growing faster. If you too want to succeed in this modern time, connect with us. We provide-</p>
                        <ul>
                            <li>Security To Your Hotel Residents</li>
                            <li>Security To Your oOfice Staffs</li>
                            <li>Exclusive connectivity with the most important members within a workplace</li>
                        </ul>
                        <p className='service_des_p'> If you want the best services in setting up these products, connect with us, our experts will tell you all about their features and benefits according to your business goals. </p>
                    </Col>
                </Row>
            </Row>
        </Container>
    )
}

export default ServiceTabTwo